export const hideToastMixin = {
  data() {
    return {
      isHide: false,
    }
  },
  async mounted() {
    document.addEventListener('mousemove', (e) => {
      if (window.innerHeight - e.clientY < 100 && this.online === false) {
        const toasterArea = document.querySelector('#b-toaster-bottom-right')
        this.isHide = true
        if (toasterArea) {
          toasterArea.style.pointerEvents = 'none'
        }
      } else {
        this.isHide = false
        const toasterArea = document.querySelector('#b-toaster-bottom-right')
        if (toasterArea) {
          toasterArea.style.pointerEvents = 'auto'
        }
      }
    })
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.onClick)
  },
}
